import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34999422"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["name", "value", "disabled", "indeterminate", "data-test"]

import { withDefaults, computed, watch } from 'vue'

type PropsType = {
  modelValue?: string | boolean | { [key: number]: string }[]
  value?: string | number | boolean
  dataTest?: string
  name?: string
  label?: string
  eventColor?: string
  disabled?: boolean
  indeterminate?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleCheckbox',
  props: {
    modelValue: { type: [String, Boolean, Array] },
    value: { type: [String, Number, Boolean] },
    dataTest: null,
    name: null,
    label: { default: '' },
    eventColor: null,
    disabled: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false }
  },
  emits: ["update:modelValue", "update:indeterminate"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: string | boolean | { [key: number]: string }[] | undefined): void
  (e: 'update:indeterminate', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue?: string | boolean | { [key: number]: string }[], value?: string | number | boolean, dataTest?: string, name?: string, label: string, eventColor?: string, disabled: boolean, indeterminate: boolean };





const internalIndeterminateValue = computed({
  get: () => props.indeterminate,
  set: (value) => {
    emit('update:indeterminate', value)
  },
})

const internalCheckedValue = computed({
  get: () => props.modelValue,
  set(value) {
    emit('update:modelValue', value)
  },
})

watch(internalCheckedValue, () => {
  // 1度でもチェックボックスの値が変更されたらindeterminateの値はクリアする
  internalIndeterminateValue.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", null, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(internalCheckedValue) ? (internalCheckedValue).value = $event : null)),
      class: _normalizeClass(["simple_checkbox", __props.eventColor]),
      type: "checkbox",
      name: __props.name,
      value: __props.value,
      disabled: __props.disabled,
      indeterminate: _unref(internalIndeterminateValue),
      "data-test": __props.dataTest,
      ref: "checkbox"
    }, null, 10, _hoisted_1), [
      [_vModelCheckbox, _unref(internalCheckedValue)]
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["checkbox", { indeterminate: _unref(internalIndeterminateValue) }])
    }, [
      _withDirectives(_createElementVNode("span", { class: "label" }, _toDisplayString(__props.label), 513), [
        [_vShow, __props.label]
      ])
    ], 2)
  ]))
}
}

})